



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {traineeStatisticsClient} from "@/api/clients.context";
import {TraineeDailyStatistic, TraineeTimesTableAggregatedStatistic} from "@/api/api.clients";


@Component({
    components: {}
})

export default class traineeMathTimestableStatistic extends Vue {
    @Prop(String)
    traineeId: string = '';

    statistic: TraineeTimesTableAggregatedStatistic | null = null;


    async mounted() {
        if (this.traineeId.length > 0) {
            this.statistic = await traineeStatisticsClient.getMultiplicationTableStatistic(this.traineeId);
        }
    }

    @Watch('traineeId')
    async onPropertyChanged(value: string, oldValue: string) {
        if (value && value.length > 0) {
            this.statistic = await traineeStatisticsClient.getMultiplicationTableStatistic(value);
        } else {
            this.statistic = null;
        }
    }

    private onTableSelected(table:number){
        this.$emit('table-selected',table);
    }

}

